class Menu {
  constructor() {
    this.menu = document.querySelector('.c-header__menu');

    if (!this.menu) {
      return;
    }

    this.nav = this.menu.querySelector('.c-header__nav');
    this.open = this.menu.querySelector('.c-header__btn--open');
    this.close = this.menu.querySelector('.c-header__btn--close');

    this.navLinks = this.menu.querySelector('.c-header__nav-links');

    this.breakpoint = window.matchMedia('(min-width: 768px)');

    this.menuToggle();
    this.headerMenuDropdowns();
  }

  menuToggle() {
    this.open.addEventListener(
      'click',
      () => {
        this.nav.classList.add('is-open');
      },
      {
        passive: true,
      },
    );

    this.close.addEventListener(
      'click',
      () => {
        this.nav.classList.remove('is-open');
      },
      {
        passive: true,
      },
    );
  }

  headerMenuDropdowns() {
    if (this.navLinks) {
      const dropdownItems = this.navLinks.querySelectorAll(
        '.menu-item-has-children',
      );

      if (dropdownItems.length) {
        let clicked = false;

        dropdownItems.forEach(dropdownItem => {
          const link = dropdownItem.querySelector('.c-header__nav-link');

          link.addEventListener('click', e => {
            if (e.target.classList.contains('is-caret')) {
              e.preventDefault();
              const item = e.currentTarget.parentElement;
              item.classList.toggle('is-open');

              clicked = true;

              setTimeout(() => {
                clicked = false;
              }, 100);
            }
          });

          let timerOut = null;
          dropdownItem.addEventListener('mouseout', () => {
            clearTimeout(timerOut);
            timerOut = setTimeout(() => {
              const openItem = this.navLinks.querySelector(
                '.c-header__nav-item.is-open',
              );

              if (openItem && (!clicked || this.breakpoint.matches)) {
                openItem.classList.remove('is-open');
              }
            }, 50);
          });

          let timerOver = null;
          dropdownItem.addEventListener('mouseover', e => {
            const item = e.currentTarget;

            clearTimeout(timerOver);
            timerOver = setTimeout(() => {
              if (!clicked || this.breakpoint.matches) {
                item.classList.add('is-open');
              }
            }, 50);
          });
        });
      }
    }
  }
}

export default new Menu();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/goodie-wp-chisel/src/scripts/modules/menu.js